/**
 * Backoff schedule for a transient failure (failure.ts). Not specified by
 * the plan — an artisan's call, same discipline as Task 10's rate
 * limit ("artisan's call, same sizing discipline"): retry fast enough
 * that a real blip resolves before a visitor notices, slow enough that a
 * genuinely down origin doesn't get hammered.
 *
 * Pure — no timers, no fetch — so the schedule itself is unit-testable
 * without a fake clock.
 */

/** After this many transient attempts, `arrival.ts` stops retrying on
 *  its own and shows the tap-to-retry affordance (`TRANSIENT_EXHAUSTED_COPY`).
 *  Not "dead" — no server ever definitively said so — just no longer
 *  silently retrying forever. */
export const MAX_AUTO_RETRIES = 4;

/** Exponential backoff, capped, with the first retry near-immediate (a
 *  blip is usually gone within a second). `attemptIndex` is 0 for the
 *  first retry. */
export function backoffMs(attemptIndex: number): number {
  return Math.min(400 * 2 ** attemptIndex, 4000);
}
